import requests from "./httpServices";

const CustomerServices = {

  addCustomerApi: async (body) => {
    return requests.post("/customers", body);
  },

  getCustomerListApi: async (params) => {
    return requests.get("/customers", params);
  },

};

export default CustomerServices;
